import { ButtonObject } from 'shared/types/notebookTypes';

export const buttonsArray: ButtonObject[] = [
  { id: 1, className: 'ql-bold' },
  { id: 2, className: 'ql-italic' },
  { id: 3, className: 'ql-underline' },
  { id: 4, disabled: true, className: 'separator', innerText: '|' },
  { id: 5, className: 'ql-align', value: 'center' },
  { id: 6, className: 'ql-align', value: 'right' },
  { id: 7, className: 'ql-align', value: 'justify' },
  { id: 8, disabled: true, className: 'separator', innerText: '|' },
  { id: 9, className: 'ql-color bg-blue', value: 'blue' },
  { id: 10, className: 'ql-color bg-purple', value: 'rgba(193,162,246,0.5)' },
  { id: 11, className: 'ql-color bg-red', value: 'red' },
  { id: 12, className: 'ql-color bg-orange', value: 'orange' },
  { id: 13, className: 'ql-color bg-green', value: 'green' },
  { id: 14, className: 'ql-color close-pen', value: '#111' },
  { id: 15, disabled: true, className: 'separator', innerText: '|' },
  { id: 16, className: 'ql-background bg-blue', value: 'rgba(0,0,255,0.5)' },
  {
    id: 17,
    className: 'ql-background bg-purple',
    value: 'rgba(193,162,246,0.5)',
  },
  { id: 18, className: 'ql-background bg-red', value: 'rgba(255,0,0,0.5)' },
  { id: 19, className: 'ql-background bg-orange', value: 'orange' },
  { id: 20, className: 'ql-background bg-green', value: 'rgba(0,255,0,0.5)' },
  {
    id: 21,
    className: 'ql-background close-pen bg-gray',
    value: 'transparent',
  },
  { id: 22, className: 'ql-background', value: 'line', innerText: '- - - -' },
  {
    id: 23,
    className: 'ql-horizontal-line',
    style: { display: 'none' },
    innerText: 'H',
  },
  {
    id: 24,
    className: 'ql-vertical-line',
    style: { display: 'none' },
    innerText: 'V',
  },
  {
    id: 25,
    className: 'ql-wave-line',
    style: { display: 'none' },
    innerText: '~',
  },
];

export const formulasButton: string[] = [
  '(',
  ')',
  '=',
  '/',
  'x',
  '+',
  '-',
  '%',
  'π',
  '√',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
];

export const currentFormulasConfig: string[] = [
  '\\frac{1}{\\sqrt{2}}\\cdot 2',
  'e^{\\pi i} + 1 = 0',
  '\\frac{x}{y}',
  '\\int_{a}^{b} f(x) dx',
  '\\sum_{n=1}^{\\infty} \\frac{1}{n^2} = \\frac{\\pi^2}{6}',
  'F = ma',
];

export const allFormulas: string[] = [
  '\\frac{1}{\\sqrt{2}}\\cdot 2',
  'e^{\\pi i} + 1 = 0',
  '\\frac{x}{y}',
  '\\int_{a}^{b} f(x) dx',
  '\\sum_{n=1}^{\\infty} \\frac{1}{n^2} = \\frac{\\pi^2}{6}',
  'F = ma',
  'E = mc^2',
  '\\nabla \\cdot \\mathbf{E} = \\frac{\\rho}{\\varepsilon_0}',
  '\\sin^2(x) + \\cos^2(x) = 1',
  '\\lim_{x\\to 0} \\frac{\\sin(x)}{x} = 1',
  '\\binom{n}{k} = \\frac{n!}{k!(n-k)!}', // Бином Ньютона
  '\\Gamma(z) = \\int_0^\\infty t^{z-1} e^{-t} dt', // Гамма-функция
  '\\zeta(s) = \\sum_{n=1}^{\\infty} \\frac{1}{n^s}', // Зета-функция Римана
  '\\Delta f = f(x+\\Delta x) - f(x)', // Разность функции
  "f'(x) = \\lim_{h\\to 0} \\frac{f(x+h) - f(x)}{h}", // Определение производной
  "\\int_a^b f'(x) dx = f(b) - f(a)", // Теорема о среднем значении интеграла
  'a \\cdot b = |a| |b| \\cos(\\theta)', // Скалярное произведение векторов
  'a \\times b = |a| |b| \\sin(\\theta) n', // Векторное произведение векторов
  'n!', // Факториал
  '\\sqrt[n]{x}', // Корень степени n
  'f(x) = a_0 + a_1x + a_2x^2 + \\dots + a_nx^n', // Полином степени n
  '\\frac{d}{dx} \\sin(x) = \\cos(x)', // Производная синуса
  '\\frac{d}{dx} \\cos(x) = -\\sin(x)', // Производная косинуса
  '\\frac{d}{dx} \\tan(x) = \\sec^2(x)', // Производная тангенса
  '\\frac{d}{dx} e^x = e^x', // Производная экспоненты
  '\\frac{d}{dx} \\ln(x) = \\frac{1}{x}', // Производная натурального логарифма
  '\\frac{d}{dx} x^n = nx^{n-1}',
  '\\vec{F} = m\\vec{a}', // Векторная форма закона Ньютона
  '\\nabla^2\\phi = 0', // Уравнение Лапласа
  '\\nabla \\times \\vec{E} = -\\frac{\\partial\\vec{B}}{\\partial t}', // Уравнение Максвелла (первое)
  '\\nabla \\times \\vec{B} = \\mu_0\\vec{J} + \\mu_0\\epsilon_0\\frac{\\partial\\vec{E}}{\\partial t}', // Уравнение Максвелла (второе)
  '\\oint_C \\vec{E} \\cdot d\\vec{l} = -\\int_S \\frac{\\partial\\vec{B}}{\\partial t} \\cdot d\\vec{S}', // Закон Фарадея
  '\\nabla\\cdot\\vec{B} = 0', // Отсутствие магнитных монополей
  '\\phi = q\\varepsilon_0', // Электростатический потенциал
  '\\vec{F} = q(\\vec{E} + \\vec{v} \\times \\vec{B})', // Сила Лоренца
  '\\omega = \\frac{2\\pi}{T}', // Угловая частота
  '\\lambda = cT', // Длина волны
  '\\vec{p} = m\\vec{v}', // Импульс тела
  '\\vec{J} = \\nabla \\times \\vec{M}', // Плотность тока намагниченности
  'x = x_0 + v_0t + \\frac{1}{2}at^2', // Уравнение равномерно ускоренного движения
  '\\vec{F} = -k\\vec{x}', // Закон Гука для пружин
  'L = T - V', // Лагранжиан как разница кинетической и потенциальной энергии
  '\\tau = rF\\sin(\\theta)', // Момент силы
  '\\hbar = \\frac{h}{2\\pi}', // Приведённая постоянная Планка
  's = ut + \\frac{1}{2}at^2', // Уравнение движения тела
  'v^2 = u^2 + 2as', // Уравнение для нахождения скорости
  '\\vec{F}_{\\text{гр}} = -\\frac{Gm_1m_2}{r^2}\\hat{r}', // Закон всемирного тяготения
  'E_k = \\frac{1}{2}mv^2', // Кинетическая энергия
  'E_p = mgh', // Потенциальная энергия в гравитационном поле
  'P = \\frac{W}{\\Delta t}', // Мощность
  '\\rho = \\frac{m}{V}', // Плотность материала
  'Q = mc\\Delta T', // Количество теплоты
];
